import React, { Component } from 'react'
import withStyles from '@material-ui/core/styles/withStyles'
import TextField from '@material-ui/core/TextField'
import PropTypes from 'prop-types'

const styles = theme => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
  },
})

class CustomUnknowTextField extends Component {
  render() {
    const { classes } = this.props
    return (
      <TextField
        {...this.props}
        className={classes.textField}
        value={this.props.value}
        helperText={`'${this.props.type}' is not implemented`}
        error
        label={this.props.label}
        disabled
      />
    )
  }
}

CustomUnknowTextField.propTypes = {
  helperText: PropTypes.string,
}

export default withStyles(styles)(CustomUnknowTextField)
